import {useEffect} from 'react';
import {resetToPlatformClient} from 'src/app/security/authentication/configureAmplify';

// Platform entry pages (invitation, magic link, vendor signup) must leave any SSO runtime client on mount.
export const useResetToPlatformClient = (): void => {
  useEffect(() => {
    resetToPlatformClient();
  }, []);
};
